<template>
    <div>
        <v-overlay z-index="4" v-if="!hideOverlay"/>
        <v-navigation-drawer absolute :right="right" style="z-index: 4" :width="width" :hide-overlay="!hideOverlay">
            <slot/>
        </v-navigation-drawer>
    </div>
</template>

<script>
export default {
    name: 'ModalDrawer',
    props: {
        right: {
            type: Boolean,
            default: true
        },
        width: {
            type: Number,
            default: 400
        },
        hideOverlay: {
            type: Boolean,
            default: true
        }
    }
}
</script>

<style scoped>

</style>
